"use client";

import "@/app/help/help-error.css";
import { Button } from "@/components/ui/shadcn/button";
import Link from "next/link";

import { memo } from "react";

const HelpError = memo(function HelpError(
  { reset }: { error: Error & { digest?: string }; reset: () => void }
) {
  return (
    <div className="dw-help-error" data-component="HelpError" data-location="src/app/help/HelpError.tsx">
      <div className="dw-help-error__content">
        <h1 className="dw-text-title">Help center unavailable</h1>
        <p data-tone="muted">We encountered an error loading this help page.</p>
        <div className="dw-help-error__actions">
          <Button onClick={reset}>Try again</Button>
          <Button asChild variant="outline">
            <Link href="/help">Help home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
});

export default HelpError;
